import React from "react";
import { ShieldX } from "lucide-react";

export default function QuotationAccessDenied() {
  return (
    <section
      className="mx-auto mt-12 max-w-xl rounded-lg border bg-card p-8 text-center shadow-brutal"
      data-testid="quotation-access-denied"
    >
      <ShieldX className="mx-auto mb-4 h-10 w-10 text-destructive" />
      <h2 className="text-xl font-semibold">Quotation access denied</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Quotation History is available only to Staff and Admin.
      </p>
    </section>
  );
}
